import 'hammerjs';
import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {AUTHSETTINGS, AUTHSTORAGE} from '@mydocma/auth';
import {MYDOCMASETTINGS} from '@mydocma/core';
import {APP_CONTAINER_SETTINGS} from '@mydocma/app-container';
import {IMmConfig} from '@docma-mm-core/project/project.interface';
import {ConfigProvider} from '@mydocma/common';
import {MM_CONFIG} from '@docma-mm-core/config/mm.config';
import {TASK_CONFIG, WEBSOCKET_CONFIG as MYDOCMA_WEBSOCKET_CONFIG} from '@mydocma/task';
import {MYDOCMA_SETTINGS_CONFIG} from '../projects/mydocma/mm/src/lib/mydocma-settings/settings-config';
import {SUPPORT_CONFIG} from '@docma-mm-core/ticket/support.config';
import {BIM_CONFIG} from '../projects/mydocma/mm/src/lib/bp-common/config/config';
import {LOGGER_CONFIG} from '@mydocma/common/src/lib/logger';
import {REPORTING_CONFIG} from '@docma-mm-core/config/reporting.config';

if (environment.production) {
  enableProdMode();
}


async function main() {

  try {

    //const configProvider = new ConfigProvider(environment,'/assets/configs/config.test_local.json');
    const configProvider = new ConfigProvider<IMmConfig>(null);
    const config = await configProvider.loadConfigAsync();

    await platformBrowserDynamic([

      {provide: LOGGER_CONFIG, useValue: config},

      {provide: AUTHSETTINGS, useValue: config.authConfig},
      {provide: AUTHSTORAGE, useValue: sessionStorage},
      {provide: MYDOCMASETTINGS, useValue: config.mydocmaConfig},
      {provide: APP_CONTAINER_SETTINGS, useValue: config.appContainerConfig},

      {provide: MM_CONFIG, useValue: config.mmConfig },
      {provide: REPORTING_CONFIG, useValue: config.reportingConfig },
      {provide: TASK_CONFIG, useValue: config.taskConfig},
      {provide: MYDOCMA_WEBSOCKET_CONFIG, useValue: config.webSocketConfig},
      {provide: MYDOCMA_SETTINGS_CONFIG, useValue: config.settingsConfig},
      {provide: SUPPORT_CONFIG, useValue: config.supportConfig},
      {provide: BIM_CONFIG, useValue: config.bimConfig }

    ]).bootstrapModule(AppModule).then(() => {
      // if ('serviceWorker' in navigator && environment.production) {
      //   navigator.serviceWorker.register('ngsw-worker.js');
      // }
    })
  } catch (error) {
    console.error(error);
  }
}

main()
